import React, { useState } from 'react';

const Header = ({ currentProfile, setCurrentProfile, profiles, profileKeys, currentPage }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleProfileChange = (profileKey) => {
    setCurrentProfile(profileKey);
    setIsDropdownOpen(false);
  };

  return (
    <div className="header">
      <h1 className="page-title">{currentPage}</h1>
      <div className="user-profiles">
        <div className="profile-dropdown">
          <button 
            className={`profile-button ${isDropdownOpen ? 'active' : ''}`}
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            👤 {profiles[currentProfile].name}
          </button>
          {isDropdownOpen && (
            <div className="dropdown-menu">
              <div className="dropdown-item demo-mode">
                🧪 Demo Mode
              </div>
              {profileKeys.map(profileKey => (
                <div
                  key={profileKey}
                  className={`dropdown-item ${currentProfile === profileKey ? 'active' : ''}`}
                  onClick={() => handleProfileChange(profileKey)}
                >
                  {getProfileIcon(profileKey)} {profiles[profileKey].name}
                </div>
              ))}
            </div>
          )}
        </div>
        <button className="profile-button">
          Lvl 1
        </button>
      </div>
    </div>
  );
};

const getProfileIcon = (profileKey) => {
  const icons = {
    newUser: '👤',
    withTokens: '📁',
    withGLDT: '💎',
    withNICP: '💧',
    withStakes: '⭐'
  };
  return icons[profileKey] || '👤';
};

export default Header;
